export default {
  unknown: 'Unknown',
  anonymous: 'Anonymous',
  activeCall: 'Active Call',
} as const;
